
import crypto from 'crypto'
import { REACT_APP_SECRET_KEY } from '../settings';

var encryption_key = REACT_APP_SECRET_KEY || 'tegra'

function descryptoValue(ciph: any) {
  var decipher = crypto.createDecipher('des-ede3-cbc', encryption_key);
  var txt = decipher.update(ciph, 'base64', 'utf8');
  return txt += decipher.final('utf8');
}

async function cryptoValue(plaintext: any) {
  if (!plaintext) return
  var cipher = crypto.createCipher('des-ede3-cbc', encryption_key);
  var ciph = cipher.update(plaintext, 'utf8', 'base64');
  return ciph += cipher.final('base64');
}

export { descryptoValue, cryptoValue }